export const ActionTypes = {
  CLEAR_GROUP: "CLEAR_GROUP",
  GET_GROUP: "GET_GROUP",
  GET_GROUP_RESULTS: "GET_GROUP_RESULTS",
  GET_USER_PERMISSIONS: "GET_USER_PERMISSIONS",
  GET_USER_PERMISSIONS_RESULTS: "GET_USER_PERMISSIONS_RESULTS",
} as const;
